import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ROUTES } from '../../routes';
import AtualizarStatusPage from './AtualizarStatusPage';
import { DriverRouteProvider } from './DriverRouteContext';
import PontoDetailPage from './PontoDetailPage';
import RoteirosListPage from './RoteirosListPage';
import { DriverShell } from './Roteiros.styles';

const DRIVER_ROLE = 'ROLE_DRIVER';

function DriverOnlyRoute({ children }) {
    const { user, isLoading } = useAuth();
    const userRoles = user?.roles || [];

    if (isLoading) {
        return <div>Carregando...</div>;
    }

    if (!userRoles.includes(DRIVER_ROLE)) {
        return <Navigate to={ROUTES.DASHBOARD} replace />;
    }

    return children;
}

export default function Roteiros() {
    return (
        <DriverOnlyRoute>
            <DriverShell>
                <Routes>
                    <Route index element={<RoteirosListPage />} />
                    <Route path=":id" element={<DriverRouteProvider />}>
                        <Route path="pontos/:pontoId" element={<PontoDetailPage />} />
                        <Route path="pontos/:pontoId/status" element={<AtualizarStatusPage />} />
                    </Route>
                    <Route path="*" element={<Navigate to={ROUTES.ROTEIROS} replace />} />
                </Routes>
            </DriverShell>
        </DriverOnlyRoute>
    );
}
